export const TabSales = [
  {
    id: 1,
    isVisible: true,
    link: '/subscription-sales/basic-sales/product',
    blocked: '/subscription-sales/basic-sales/blocked',
    title: 'Products & Inventory',
    type: 'dropdown',
    access: 'product_inventory',
    isGranted: true,
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/basic-sales/product',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Product list',
        type: 'link',
        access: 'product_inventory',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/basic-sales/variant',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Variant options',
        type: 'link',
        access: 'product_inventory',
        isGranted: true,
      },
      {
        id: 6,
        isVisible: false,
        link: '/subscription-sales/basic-sales/modifier',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Modifiers',
        type: 'link',
        access: 'product_inventory',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/category',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Categories',
        type: 'link',
        access: 'product_inventory',
        isGranted: true,
      },
    ],
  },
  {
    id: 2,
    isVisible: false,
    link: '/subscription-sales/basic-sales/tax',
    blocked: '/subscription-sales/basic-sales/blocked',
    title: 'Taxes & other charges',
    type: 'link',
    access: 'tax_and_charges',
    isGranted: true,
  },
  {
    id: 3,
    isVisible: false,
    title: 'Customers',
    type: 'dropdown',
    subTab: [
      {
        id: 3424234209,
        isVisible: false,
        link: '/subscription-sales/basic-sales/customers',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Customer list',
        type: 'link',
        access: 'customers',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/basic-sales/customers/label',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Customer label',
        type: 'link',
        access: 'customers',
        isGranted: true,
      },
    ],
  },

  {
    id: 4,
    isVisible: false,
    link: '/subscription-sales/basic-sales/discount',
    blocked: '/subscription-sales/basic-sales/blocked',
    title: 'Discounts',
    type: 'link',
    access: 'discounts',
    isGranted: true,
  },

  {
    id: 5,
    isVisible: false,
    link: '/subscription-sales/basic-sales/transaction',
    blocked: '/subscription-sales/basic-sales/blocked',
    title: 'Transaction list',
    type: 'link',
    access: 'transaction_list',
    isGranted: true,
  },

  {
    id: 312893081319238,
    isVisible: false,
    link: '/subscription-sales/basic-sales/sales-summary',
    blocked: '/subscription-sales/basic-sales/blocked',
    title: 'Sales report',
    access: 'reports',
    isGranted: true,
    type: 'dropdown',
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/basic-sales/sales-summary',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Sales summary',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/basic-sales/gross-profit',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Gross profit',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 6,
        isVisible: false,
        link: '/subscription-sales/basic-sales/payment-methods',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Payment methods',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/product-sales',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Product sales',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/category-sales',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Category sales',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/modifiers-sales',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Modifiers sales',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73997,
        isVisible: false,
        link: '/subscription-sales/basic-sales/discount-sales',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Discount',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/tax-sales',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Taxes & other charges',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/compliments-given',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Compliments given',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/voids',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Voids',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/dining-option',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Dining option',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/cash-drawers',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Cash drawers',
        type: 'link',
        access: 'reports',
        isGranted: true,
      },
    ],
  },
  {
    id: 34242342424,
    isVisible: false,
    link: '/subscription-sales/basic-sales/compliments-voids',
    blocked: '/subscription-sales/basic-sales/blocked',
    title: 'Sales settings',
    type: 'dropdown',
    access: 'sales_setting',
    isGranted: true,
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/basic-sales/compliments-voids',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Compliments & voids',
        type: 'link',
        access: 'sales_setting',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/basic-sales/check-out-setting',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Check-out settings',
        type: 'link',
        access: 'sales_setting',
        isGranted: true,
      },
      {
        id: 6,
        isVisible: false,
        link: '/subscription-sales/basic-sales/setting/receipts',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Receipts',
        type: 'link',
        access: 'sales_setting',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/setting/dining-options',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Dining options',
        type: 'link',
        access: 'sales_setting',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/basic-sales/setting/payments',
        blocked: '/subscription-sales/basic-sales/blocked',
        title: 'Payment methods',
        type: 'link',
        access: 'sales_setting',
        isGranted: true,
      },
    ],
  },
];
